__turbopack_context__.v({
  "DropZone": "drop-zone-module__roVnUq__DropZone",
  "Overlay": "drop-zone-module__roVnUq__Overlay",
});
